import React from 'react';
import Wrapper, { ButtonPayment } from './style';
import {
  paymentPersonal,
  paymentBusiness,
  paymentEnterprise,
  star,
} from '../../assets';
import { licenseID } from '../../configs/license';
import { toRupiah, pluralWriter } from '../../utils/commonUtils';

const typeList = [
  {
    value: licenseID.personal.id,
    label: licenseID.personal.name,
    image: paymentPersonal,
  },
  {
    value: licenseID.business.id,
    label: licenseID.business.name,
    image: paymentBusiness,
  },
  {
    value: licenseID.enterprise.id,
    label: licenseID.enterprise.name,
    image: paymentEnterprise,
  },
];

const Index = (props) => {
  const {
    className,
    // licenseTypeName,
    licenseType,
    licenseName,
    licenseKuota,
    licenseMax,
    licensePrice,
    onClickButton,
    showButton = false,
    showDescription = false,
    licenseDescription,
    block,
  } = props;

  const isSelectedType = typeList.filter((item) => {
    return item.value === licenseType;
  })[0];

  return (
    <Wrapper
      className={className}
      backgroundImage={isSelectedType?.image}
      block={block}
    >
      {!isSelectedType && <UnlicensedCard />}
      {isSelectedType && (
        <div className="container_payment_card">
          <div className="container_payment_card_header d-flex">
            <div className="font-subtitle1_bold">{licenseName}</div>
            {/* <div className="font-paragraph_medium  container_payment_card_header_badge d-flex">
              {licenseTypeName}
            </div> */}
          </div>
          <div className="container_payment_card_body d-flex">
            <div className="font-paragraph_medium">
              {!showDescription
                ? `${licenseKuota}
                ${pluralWriter({
                  word: 'Member',
                  value: licenseKuota,
                })}
                ${
                  licenseMax
                    ? `| ${licenseMax} ${pluralWriter({
                        word: 'Account',
                        value: licenseMax,
                      })}`
                    : ''
                }`
                : `${licenseDescription}`}
            </div>
            <div className="font-subtitle1_medium">
              {toRupiah(licensePrice || 0)}
            </div>
          </div>
          {showButton && (
            <ButtonPayment block onClick={onClickButton}>
              Buy License
            </ButtonPayment>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default Index;

const UnlicensedCard = () => {
  return (
    <div className="container_payment_card_unlicensed">
      <div className="component_unlicensed_image">
        <img src={star} alt="unlicensed icon" />
      </div>
      <div className="component_unlicensed_text">
        <div className="font-subtitle1_medium">
          You do not have an active license
        </div>
        <div className="font-paragraph">
          Please buy a license to use AlphaVeritas features
        </div>
      </div>
    </div>
  );
};
